import { render } from "./WindTable.vue?vue&type=template&id=826a837e&scoped=true&ts=true"
import script from "./WindTable.vue?vue&type=script&lang=ts"
export * from "./WindTable.vue?vue&type=script&lang=ts"

import "./WindTable.vue?vue&type=style&index=0&id=826a837e&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826a837e"]])

export default __exports__